import org.koin.compose.viewmodel.dsl.viewModelOf
import org.koin.dsl.module

actual val viewModelModule = module {
    single<PlayerPreferences> { JsPlayerPreferences() }
    viewModelOf(::BankoStartScreenViewModel)
    viewModelOf(::BankoGameScreenViewModel)
}
